import React from 'react';
import BannerCard from '../banner-card/BannerCard';
import Project from '../project/ProjectBox';
import './Projects.css';
import { isMobile } from 'react-device-detect';
import BannerText from '../banner-text/BannerText';

export default function Projects(props) {

    const filteredProjects = props.projects || [];

    return (
            <section className="card-section cards-slider">
                <div className="content-container">

                    <div className="card-wrapper">

                        {
                            filteredProjects.length === 0 && "לא נמצאו התנדבויות.."
                        }
                        {
                            filteredProjects.map((item, i) =>  (
                                <React.Fragment key={i}>
                                {i === 8 && !isMobile && <BannerCard
                                    leadingColor={props.leadingColor}
                                    banner_img_src={props.partner.partnerConfig.adImageUrl}
                                    banner_img_alt={props.partner.partnerConfig.adMessageAltText}
                                    banner_title={props.partner.partnerConfig.adMessage}
                                    banner_content={props.partner.partnerConfig.adMessageSubTitle}
                                />}
                                <Project partnerName={props.partner.partnerLink} project_fields={item}/>
                                {/* {!isMobile && i === 5 && <BannerText color={props.leadingColor} content={props.partner.partnerConfig.message}/>} */} {/** text bunner */}
                                </React.Fragment>
                            ))
                        }

                    </div>
                    {/* <div className="footer-section-link-wrapper"> 
                        <a href="index-column-mobile-card" className="footer-section-link"> הצג עוד </a> 
                    </div> */}
                </div>
            </section>
    )
}
